export const GET_USER_INFO = '/app/promotion/prom_user_info.cgi';
export const SET_USER_BITMAP = '/app/promotion/prom_set_user_bitmap.cgi';
export const QRY_USER_PROFILE = '/app/promotion/prom_qry_user_profile.cgi';
